// 空検索はコレクション一覧へ送り、商品検索の1,000件制限を避ける。Refs #547
// キーワードありの検索は、商品説明を含む従来の検索を維持する。
(() => {
  const ALL_TERMS = '*';
  const CANONICAL_TYPE = 'product';

  const isSearchPath = (pathname) => pathname === '/search' || pathname.endsWith('/search');

  // 表示上の検索語を変えず、送信する q にだけカテゴリの所属条件を付ける。
  // formdata は通常の送信と form.submit() の両方で発火する。
  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!isSearchPath(new URL(form.action, window.location.origin).pathname)) return;
    const scope = form.querySelector('[data-search-scope-category]');
    if (!scope) return;
    event.formData.delete('scope');
    const handle = scope.value.trim();
    if (!handle) return;
    // カテゴリ条件の外へ OR 等が漏れないよう、入力した記号を文字として扱う。
    const escapeTerm = (value) => value.replace(/[\\"():]/g, '\\$&');
    const term = (event.formData.get('q') || '').trim() || ALL_TERMS;
    event.formData.set('q', `tag:"col:${escapeTerm(handle)}" AND (${escapeTerm(term)})`);
    event.formData.set('type', CANONICAL_TYPE);
  });

  // テーマが出力するURLを使い、言語別のルートも維持する。
  const allProductsPath = document.querySelector('[data-search-all-products-url]')?.dataset.searchAllProductsUrl
    || '/collections/all';

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.origin);
    if (action.origin !== window.location.origin || !isSearchPath(action.pathname)) return;
    const input = form.querySelector('input[name="q"]');
    if (!(input instanceof HTMLInputElement)) return;
    if (input.value.trim() !== '' && input.value.trim() !== ALL_TERMS) return;

    const handle = form.querySelector('[data-search-scope-category]')?.value.trim();
    const destination = new URL(allProductsPath, window.location.origin);
    if (handle) destination.pathname = destination.pathname.replace(/\/all\/?$/, `/${encodeURIComponent(handle)}`);
    destination.searchParams.set('view', 'search');
    // 旧フォームの絞り込みとテーマプレビューを保つ。検索ページのページ番号は持ち込まない。
    const fields = new FormData(form);
    for (const [key, value] of fields) {
      if (key.startsWith('filter.') && value) destination.searchParams.append(key, value);
    }
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) destination.searchParams.set('preview_theme_id', preview);
    event.preventDefault();
    window.location.assign(destination.toString());
  }, true);
})();
